import 'flowbite/dist/flowbite.turbo.js';
import '@hotwired/turbo-rails'
import './controllers'
